import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  GetNotificationsPayload,
  RequestIdPayload,
  ReadNotificationPayload,
} from "type/notification";

export const notifications = createApi({
  reducerPath: "notifications",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getNotifications: builder.query<any, GetNotificationsPayload>({
      query: ({ id, startDate, endDate, page }) => ({
        url: `notifications/${id}?startDate=${startDate}&endDate=${endDate}&page=${page}`,
        method: "GET",
      }),
    }),
    getUnReadNotifications: builder.query<any, ReadNotificationPayload>({
      query: ({ id }) => ({
        url: `notifications/${id}/count`,
        method: "GET",
      }),
    }),
    notificationViewed: builder.mutation<any, RequestIdPayload>({
      query: ({ id }) => ({
        url: `notifications/${id}/viewed`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useGetUnReadNotificationsQuery,
  useNotificationViewedMutation,
} = notifications;
